export const mandatoryPhone = {
  'Hello, friend!': '¡Hola!',
  'We could not find your cellphone number through your social login':
    'Lamentablemente no pudimos encontrar tu número de celular a través de tu inicio de sesión social',
  'Please fill in the field below to continue browsing':
    'Por favor, completá el campo de abajo para continuar navegando',
  PHONE_PLACEHOLDER: 'XXXX XXXXX',
};
